import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faPenToSquare, faCircleXmark, faTrashCan, faPlus } from '@fortawesome/free-solid-svg-icons';
import Pagination from '../../components/layout/Pagination'
import { toast } from 'react-toastify';

function Products() {
  const [products, setProducts] = useState([])
  const token = localStorage.getItem('authToken');
  const [modalOpen, setModalOpen] = useState(false); // Модал за едитирање на целосен продукт
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [newQuantity, setNewQuantity] = useState(null);
  const [editingQuantity, setEditingQuantity] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortBy, setSortBy] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [errorMessage, setErrorMesage] = useState('')
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [uploadedImages, setUploadedImages] = useState([])
  const [searchedProduct, setSearchedProduct] = useState('');

  const API_URL = process.env.REACT_APP_API_URL;

  const [errors, setErrors] = useState({});

  const categoryOptions = [
    { label: 'Масло', value: 0 },
    { label: 'Адитив', value: 1 },
    { label: 'Филтер за масло', value: 2 },
    { label: 'Филтер за воздух', value: 3 },
    { label: 'Филтер за гориво', value: 4 },
    { label: 'Филтер за кабина', value: 5 }
  ];

  const location = useLocation()
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sortByUrl = queryParams.get('sortBy') ?? '';
    const pageSizeUrl = queryParams.get('pageSize') ?? pageSize;
    const currentPageUrl = queryParams.get('currentPage') ?? 1;
    const totalPagesUrl = queryParams.get('totalPages') ?? 0;
    setCurrentPage(currentPageUrl)
    setTotalPages(totalPagesUrl)
    setSortBy(sortByUrl)
    setPageSize(pageSizeUrl)
    fetchProducts(searchedProduct, sortByUrl, pageSizeUrl, currentPageUrl)
  }, [location.search])

  const fetchProducts = async (searchedProduct, sortBy, pageSize, currentPage) => {
    try {
      setLoading(true)

      const response = await fetch(`${API_URL}/Item/items?itemName=${searchedProduct}&sortBy=${sortBy}&pageNumber=${currentPage}&pageSize=${pageSize}`, {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${token}`,
          'Content-Type': 'application/json',  // Specify the content type
        }
      })

      if (response.status === 401) {
        navigate('/');
      }

      const result = await response.json()
      if (result?.data?.items) {
        const newQueryParams = new URLSearchParams(location.search);
        setProducts(result.data.items);
        setTotalPages(result.data.totalPages);
        setTotalItems(result.data.totalItems);
        setLoading(false)

        if (result.data.totalPages) {
          newQueryParams.set("totalPages", result.data.totalPages);
        }
        //navigate({ search: newQueryParams.toString() });
      } else {
        setProducts([])
        setLoading(false)
      }
    }
    catch (error) {
    }
  }

  const openAddModal = () => {
    setSelectedProduct({
      title: '',
      price: 0,
      discountedPrice: 0,
      stock: 0,
      manufacturer: '',
      category: 0,
      itemNumber: '',
      eANNumber: '',
      imageLinks: [],
      description: '',
      recomendations: '',
      specification: '',
      capacity: '',
      saeViscosity: '',
      version: '',
      filterType: '',
      diameter: '',
      diameter1: '',
      width: '',
      width1: '',
      height: '',
      height1: '',
      length: '',
      length1: '',
      innerDiameter: '',
      innerDiameter2: '',
      weight: '',
      supplementaryArticle: '',
      fuelType: '',
      inletMM: '',
      outletMM: '',
      cabinFilterType: '',
      characteristics: '',
      application: '',
      use: '',
      material: '',
    });
    setModalOpen(true);
  };

  // Функција за отварање на модал за целосно едитирање на продуктот
  const openEditModal = (product) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };

  // Функција за затворање на модалот за едитирање на продукт
  const closeEditModal = (shouldDeleteImage) => {
    deleteImageIfCancelled(shouldDeleteImage)
    setModalOpen(false);
    setSelectedProduct(null);
    setErrors({});
    setErrorMesage("")
  };

  const handleProduct = () => {
    if (selectedProduct.id) {
      handleProductEdit()
    } else {
      handleProductAdd()
    }
  };

  // Функција за чување на едитираните податоци
  const handleProductEdit = async () => {
    setLoading(true)
    const validationErrors = validateInputs();

    if (validationErrors) {
      setErrors(validationErrors);
      setLoading(false)
      return;
    }
    const response = await fetch(`${API_URL}/Item/${selectedProduct.id}`, {
      method: 'PUT',
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',  // Specify the content type
      },
      body: JSON.stringify(selectedProduct),
    })

    const result = await response.json()
    if (result.statusCode === 204) {
      setProducts(products.map(product =>
        product.id === selectedProduct.id ? selectedProduct : product
      ));
      closeEditModal(false);
      setLoading(false);
      setUploadedImages([]);
      toast.success(`${selectedProduct.title} е успешно ажуриран!`);
    } else {
      setErrors({});
      setErrorMesage("Продуктот не е успешно променет!");
      setLoading(false)
    }
  };

  const handleProductAdd = async () => {
    setLoading(true)
    const validationErrors = validateInputs();

    if (validationErrors) {
      setErrors(validationErrors);
      setLoading(false)
      return;
    }

    try {
      const response = await fetch(`${API_URL}/Item/addItem`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${token}`,
          'Content-Type': 'application/json',  // Specify the content type
        },
        body: JSON.stringify(selectedProduct),
      })

      const result = await response.json()

      if (result.statusCode === 201) {
        setProducts([...products, result.data]);
        closeEditModal(false);
        setLoading(false)
        setUploadedImages([])
        toast.success(`${selectedProduct.title} е успешно додаден!`);
      } else {
        setErrors({});
        setErrorMesage("Продуктот не е успешно додаден!");
        setLoading(false)
      }
    }
    catch {
      setErrors({});
      setErrorMesage("Продуктот не е успешно додаден!");
      setLoading(false)
    }
  };

  const openEditQuantity = (product) => {
    setEditingQuantity(product.id);
    setNewQuantity(product.quantity);
  };

  const handleQuantity = (e) => {
    setNewQuantity(e.target.value)
  }

  const saveQuantity = async (product) => {
    setLoading(true)

    const response = await fetch(`${API_URL}/Item/UpdateItemStock?itemId=${product.id}&stock=${newQuantity}`, {
      method: 'PUT',
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',  // Specify the content type
      }
    })

    const result = await response.json()

    if (result.statusCode === 201) {
      setProducts(products.map(p =>
        p.id === product.id ? { ...p, stock: newQuantity } : p
      ));
      setLoading(false)
      toast.success(`Залихата на ${product.title} е успешно променета!`);
    } else {
      setLoading(false)
    }
    setEditingQuantity(null);
  };

  const validateInputs = () => {
    const newErrors = {};

    if (!selectedProduct.title) newErrors.title = "Насловот е задолжителен!";
    if (!selectedProduct.manufacturer) newErrors.manufacturer = "Производителот е задолжителен!";
    if (selectedProduct.price === "" || selectedProduct.price === null || selectedProduct.price === undefined || isNaN(selectedProduct.price))
      newErrors.price = "Цената е задолжителна!";
    if (!selectedProduct.description) newErrors.description = "Описот е задолжителен!";
    if (selectedProduct.stock === "" || selectedProduct.stock === null || selectedProduct.stock === undefined || isNaN(selectedProduct.stock))
      newErrors.stock = "Залихата е задолжителна!";
    if (selectedProduct.category === "" || selectedProduct.category === null || selectedProduct.category === undefined || isNaN(selectedProduct.category))
      newErrors.category = "Категоријата е задолжителна!";
    if (!selectedProduct.itemNumber) newErrors.itemNumber = "Бројот на продуктот задолжителен!";

    if (selectedProduct.category === categoryOptions[0].value) {
      if (!selectedProduct.recomendations) newErrors.recomendations = "Препораката е задолжителна за категорија масло!";
      if (!selectedProduct.specification) newErrors.specification = "Спецификацијата е задолжителна за категорија масло!";
      if (!selectedProduct.capacity) newErrors.capacity = "Капацитетот е задолжителен за категорија масло!";
      if (!selectedProduct.saeViscosity) newErrors.saeViscosity = "Вискозитетот е задолжителен за категорија масло!";
      if (!selectedProduct.version) newErrors.version = "Вискозитетот е задолжителен за категорија масло!";
    }

    return Object.keys(newErrors).length > 0 ? newErrors : null;  // Врати го новиот објект со грешки ако има или null ако нема грешки
  };

  const handlePageChange = (page) => {
    const newQueryParams = new URLSearchParams(location.search);

    if (page) {
      newQueryParams.set('currentPage', page);
    } else {
      newQueryParams.delete('currentPage');
    }
    navigate({ search: newQueryParams.toString() });

    setCurrentPage(page)
  };

  const handleSortByChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    const { name, value } = e.target;

    if (value) {
      newQueryParams.set(name, value);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }
    setSortBy(e.target.value);

    navigate({ search: newQueryParams.toString() });
  };

  const handlePageSizeChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set('currentPage', '1');
    const { name, value } = e.target;

    if (value) {
      newQueryParams.set(name, value);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }
    setPageSize(e.target.value);

    navigate({ search: newQueryParams.toString() });
  };

  const deleteProduct = async (product) => {
    setLoading(true);

    const response = await fetch(`${API_URL}/Item/${product.id}`, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',  // Specify the content type
      }
    })
    const result = await response.json()

    if (result.statusCode === 204) {
      toast.success(`${product.title} е успешно избришан!`);
      setProducts(products.filter((item) => item.id !== product.id));
      setLoading(false);
      closeDeleteModal();
    } else {
      toast.warning(`${product.title} не е успешно избришан!`);
      setLoading(false);
      closeDeleteModal();
    }
  }

  const openDeleteModal = (product) => {
    setProductToDelete(product);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setProductToDelete(null);
  };

  const confirmDelete = () => {
    deleteProduct(productToDelete);
  };

  const handleImageUpload = async (files) => {
    setLoading(true)
    try {
      const formData = new FormData();

      // Додај ги сите слики во formData
      files.forEach((file) => {
        formData.append('files', file);
      });

      // Испрати ги сликите на серверот (промени ја URL-то според твојот сервер)
      const response = await fetch(`${API_URL}/Image/upload`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${token}`,
        },
        body: formData,
      });

      if (response.status === 200) {

        const result = await response.json()
        const uploadedImageUrls = result.imageUrls; // Adjust based on your server response
        const imageLinkObjects = uploadedImageUrls.map(url => ({ imageLink: url }));

        setUploadedImages((images) => ([
          ...images, ...imageLinkObjects
        ]));

        // Спои ги старите и новите слики во листата
        setSelectedProduct((prevImage) => ({
          ...prevImage,
          imageLinks: [...prevImage.imageLinks, ...imageLinkObjects],
        }));

        setLoading(false);
      }
      else {
        toast.error('Се случи проблем при додавањето на фотографијата')
        setLoading(false);
      }

    } catch (error) {
      console.error('Upload error:', error);
      setLoading(false);
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files); // Претвори ги во масив
    handleImageUpload(files); // Повикај ја функцијата за upload
  };

  const removeImage = async (image, index) => {
    setLoading(true)

    const response = await fetch(`${API_URL}/Image?url=${encodeURIComponent(image.imageLink)}&imageId=${image.id ? image.id : 0}`, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`,
      }
    })

    const result = await response.json()

    if (result) {
      setSelectedProduct((prevProduct) => ({
        ...prevProduct,
        imageLinks: prevProduct.imageLinks.filter((_, i) => i !== index), // Отстранува слика на дадениот индекс
      }));
      setLoading(false);
    }
    else {
      toast.warning('Настана проблем при бришењето на фотографијата');
      setLoading(false)
    }
  };

  const deleteImageIfCancelled = async (shouldDeleteImage) => {
    if (!shouldDeleteImage) {
      return
    }
    if (uploadedImages.length > 0) {
      setLoading(true)

      var urls = uploadedImages.map(url => url.imageLink);
      const response = await fetch(`${API_URL}/Image/deleteImages`, {
        method: 'DELETE',
        headers: {
          "content-type": 'application/json',
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(urls)
      })
      const result = await response.json()

      if (result) {
        setUploadedImages([])
        setLoading(false);
      }
      else {
        toast.warning('Настана проблем при бришењето на фотографијата');
        setLoading(false)
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearchIconClick(); // Повикај ја функцијата ако е притиснат Enter
    }
    if (event.key === 'Escape') {
      clearInput();
    }
  };

  const handleSearchIconClick = () => {
    if (searchedProduct.length > 0 && searchedProduct.length < 2) {
      return;
    }
    fetchProducts(searchedProduct, sortBy, pageSize, 1);
  };

  const clearInput = () => {
    setSearchedProduct('');
    fetchProducts('', sortBy, pageSize, currentPage);
  };


  return (
    <div className="p-6">
      <div className='flex flex-col'>
        <div className='ml-auto'>
          <label htmlFor='pageSize'>Прикажи:</label>
          <select
            className="mb-4"
            name='pageSize'
            id='pageSize'
            value={pageSize}
            onChange={handlePageSizeChange}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
        </div>
        <div className='ml-auto'>
          <select
            className="mb-4"
            name='sortBy'
            value={sortBy}
            onChange={handleSortByChange}
          >
            <option value="createdate">Стандардно подредување</option>
            <option value="price_asc">Цена &uarr; (ниска кон висока)</option>
            <option value="price_desc">Цена &darr; (висока кон ниска)</option>
            <option value="createdate">Најново додадено</option>
          </select>
        </div>
      </div>
      <div className='flex justify-between'>
        <div className="flex items-center border border-gray-300 rounded-lg p-[1px] max-w-[200px] mr-1">
          <input
            type="text"
            className="flex-grow p-1 outline-none w-full"
            placeholder="Пребарувај продукти"
            value={searchedProduct}
            onChange={(e) => setSearchedProduct(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          {searchedProduct && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              className="h-5 w-5 text-gray-500 cursor-pointer"
              onClick={clearInput}
            >
              <path
                fillRule="evenodd"
                d="M11.03 4.97a1 1 0 0 0-1.415 0L8 6.585 5.385 4.97a1 1 0 1 0-1.415 1.415L6.585 8l-2.615 2.615a1 1 0 1 0 1.415 1.415L8 9.415l2.615 2.615a1 1 0 0 0 1.415-1.415L9.415 8l2.615-2.615a1 1 0 0 0 0-1.415z"
                clipRule="evenodd"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            className="h-5 w-5 text-gray-500 cursor-pointer"
            onClick={handleSearchIconClick}
          >
            <path
              fillRule="evenodd"
              d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <button className='btn btn-primary btn-sm' onClick={openAddModal}>
          <FontAwesomeIcon icon={faPlus} />
          Додади Продукт
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="table min-w-[600px] w-full table-zebra">
          <thead>
            <tr className='text-sm'>
              <th className='w-[30px]'>Id</th>
              <th>Слика</th>
              <th>Продукт</th>
              <th>Категорија</th>
              <th>Количество</th>
              <th>Цена</th>
              <th>Намалена Цена</th>
              <th>Едитирај</th>
            </tr>
          </thead>
          <tbody>
            {products.map(product => (
              <tr key={product.id}>
                <td className='font-semibold'>{product.id}</td>
                <td className='p-0'><img className='w-[55px]' src={product.imageLinks[0]?.imageLink} alt='Слика од производ' /></td>
                <td>{product.title}</td>
                <td>{product.categoryDescription}</td>
                <td className='flex items-center'>
                  {editingQuantity === product.id ? (
                    <input
                      id='quantity'
                      type="number"
                      defaultValue={product.stock}
                      min={0}
                      onChange={handleQuantity}
                      className="input input-bordered input-sm w-20 mr-[10px]"
                    />
                  ) : (
                    <p className='inline-block w-[30px] text-right mr-[10px] text-base font-semibold'>{product.stock}</p>
                  )}
                  {editingQuantity === product.id ? (
                    <div className='inline-block'>
                      <button
                        className="btn btn-sm btn-success block mb-[5px]"
                        onClick={() => saveQuantity(product)}
                      >
                        <FontAwesomeIcon icon={faSave} />
                      </button>
                      <button
                        className="btn btn-sm btn-error block"
                        onClick={() => setEditingQuantity(null)}
                      >
                        <FontAwesomeIcon icon={faCircleXmark} />
                      </button>
                      {loading && (<span className="loading loading-spinner loading-xs"></span>)}
                    </div>
                  ) : (
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => openEditQuantity(product)}
                    >
                      <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                  )}
                </td>
                <td>{product.price} ден</td>
                <td>{product.discountedPrice > 0 ? <span className='font-bold text-red-600 text-base'>{product.discountedPrice} ден</span> : '' }</td>
                <td>
                  <button
                    className="btn btn-sm btn-primary ml-2"
                    onClick={() => openEditModal(product)}
                  >
                    <FontAwesomeIcon icon={faPenToSquare} />
                  </button>
                  <button
                    className="btn btn-sm btn-error ml-2"
                    onClick={() => openDeleteModal(product)}
                  >
                    <FontAwesomeIcon icon={faTrashCan} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {products.length > 0 && (
          <>
            <div className='text-center'>Тековна страна: {currentPage}</div>
            <div className='text-center'>Вкупно производи: {totalItems}</div>
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            /></>
        )}
      </div>

      {modalOpen && selectedProduct && (
        <div className="modal modal-open">
          <div className="modal-box max-w-[800px]">
            <div className="flex items-center justify-center p-4 flex-wrap">
              <div className='ml-auto'>
                <button onClick={() => closeEditModal(true)} disabled={loading}>
                  <FontAwesomeIcon icon={faCircleXmark} />
                </button>
              </div>
              <div className="mx-auto w-full bg-white mb-auto">
                <div>
                  <h1 className='text-4xl font-bold mb-8 mt-8 text-center'>{selectedProduct.id ? 'Промени податоци за продукт' : 'Додај нов продукт'}</h1>
                </div>
                {selectedProduct.id && (<p className='text-base'>Id - {selectedProduct.id}</p>)}
                <h3 className='text-xl mb-4'>Општи карактеристики на производ</h3>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="title" className="mb-1 block text-base font-medium text-[#07074D]">
                        Наслов<span className='text-red-500 tooltip' data-tip="Насловот е задолжителен">*</span>
                      </label>
                      <input type="text" name="title" id="title" value={selectedProduct.title}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, title: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.title && (
                        <p className="text-red-500 text-sm">{errors.title}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="manufacturer" className="mb-1 block text-base font-medium text-[#07074D]">
                        Производител<span className='text-red-500 tooltip' data-tip="Производителот е задолжителен">*</span>
                      </label>
                      <input type="text" name="manufacturer" id="manufacturer" value={selectedProduct.manufacturer}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, manufacturer: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.manufacturer && (
                        <p className="text-red-500 text-sm ">{errors.manufacturer}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="price" className="mb-1 block text-base font-medium text-[#07074D]">
                        Цена<span className='text-red-500 tooltip' data-tip="Цената е задолжителна">*</span>
                      </label>
                      <input type="number" name="price" id="price" value={selectedProduct.price}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, price: parseInt(e.target.value) })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.price && (
                        <p className="text-red-500 text-sm ">{errors.price}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="discountedPrice" className="mb-1 block text-base font-medium text-[#07074D]">
                        Намалена Цена
                      </label>
                      <input type="number" name="discountedPrice" id="discountedPrice" value={selectedProduct.discountedPrice}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, discountedPrice: parseInt(e.target.value) })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="stock" className="mb-1 block text-base font-medium text-[#07074D]">
                        Залиха<span className='text-red-500 tooltip' data-tip="Залихата е задолжителна">*</span>
                      </label>
                      <input type="number" name="stock" id="stock" min={0} value={selectedProduct.stock}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, stock: parseInt(e.target.value) })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.stock && (
                        <p className="text-red-500 text-sm ">{errors.stock}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="eanNumber" className="mb-1 block text-base font-medium text-[#07074D]">
                        EAN број<span className='text-red-500 tooltip' data-tip="EAN бројот е задолжителен">*</span>
                      </label>
                      <input type="text" name="eanNumber" id="eanNumber" value={selectedProduct.eanNumber}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, eanNumber: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.eanNumber && (
                        <p className="text-red-500 text-sm ">{errors.eanNumber}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="category" className="mb-1 block text-base font-medium text-[#07074D]">
                        Категорија<span className='text-red-500 tooltip' data-tip="Категоријата е задолжителна">*</span>
                      </label>
                      <select name="category" id="category" value={selectedProduct.category} onChange={(e) => setSelectedProduct({ ...selectedProduct, category: parseInt(e.target.value) })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" >
                        {categoryOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      {errors.category && (
                        <p className="text-red-500 text-sm ">{errors.category}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="itemNumber" className="mb-1 block text-base font-medium text-[#07074D]">
                        Број на продуктот<span className='text-red-500 tooltip' data-tip="Бројот на продуктот е задолжителен">*</span>
                      </label>
                      <input type="text" name="itemNumber" id="itemNumber" value={selectedProduct.itemNumber}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, itemNumber: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.itemNumber && (
                        <p className="text-red-500 text-sm ">{errors.itemNumber}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="imageLinks" className="mb-1 block text-base font-medium text-[#07074D]">
                        Слики<span className='text-red-500 tooltip' data-tip="Бројот на продуктот е задолжителен">*</span>
                      </label>
                      <input type="file" name="imageLinks" id="imageLinks" accept="image/*" multiple
                        onChange={handleImageChange}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-1 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm text-xs" />
                      {errors.image && (
                        <p className="text-red-500 text-sm ">{errors.image}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mt-4">
                      <h2 className="text-xl font-bold">Преглед на слики:</h2>
                      <div className="flex gap-4 ">
                        {selectedProduct.imageLinks.map((image, index) => (
                          <div key={index} className="relative">
                            <img src={image.imageLink} alt={`Слика од производот ${index + 1}`} className="w-20 h-20 object-cover rounded-md" />
                            <button
                              onClick={() => removeImage(image, index)}
                              className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1"
                            >
                              X
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 ">
                    <div className="mb-2">
                      <label htmlFor="description" className="mb-1 block text-base font-medium text-[#07074D]">
                        Опис<span className='text-red-500 tooltip' data-tip="Бројот на продуктот е задолжителен">*</span>
                      </label>
                      <textarea type="textarea" name="description" id="description" value={selectedProduct.description}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, description: e.target.value })}
                        className="textarea textarea-bordered w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" ></textarea>
                      {errors.description && (
                        <p className="text-red-500 text-sm ">{errors.description}</p>
                      )}
                    </div>
                  </div>
                </div>
                <h3 className='text-xl mb-4'>Карактеристики на масло</h3>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="recomendations" className="mb-1 block text-base font-medium text-[#07074D]">
                        Препораки (recomendations)<span className='text-red-500 tooltip' data-tip="Препораките се задолжителни за категорија масло">*</span>
                      </label>
                      <input type="text" name="recomendations" id="recomendations" value={selectedProduct.recomendations}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, recomendations: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.recomendations && (
                        <p className="text-red-500 text-sm ">{errors.recomendations}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="specification" className="mb-1 block text-base font-medium text-[#07074D]">
                        Спецификација<span className='text-red-500 tooltip' data-tip="Спцификацијата е задолжителна за категорија масло">*</span>
                      </label>
                      <input type="text" name="specification" id="specification" value={selectedProduct.specification}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, specification: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.specification && (
                        <p className="text-red-500 text-sm ">{errors.specification}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="capacity" className="mb-1 block text-base font-medium text-[#07074D]">
                        Капацитет<span className='text-red-500 tooltip' data-tip="Капацитетот е задолжителен за категорија масло">*</span>
                      </label>
                      <input type="text" name="capacity" id="capacity" value={selectedProduct.capacity}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, capacity: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.capacity && (
                        <p className="text-red-500 text-sm ">{errors.capacity}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="saeViscosity" className="mb-1 block text-base font-medium text-[#07074D]">
                        Вискозитет<span className='text-red-500 tooltip' data-tip="Спцификацијата е задолжителна за категорија масло">*</span>
                      </label>
                      <input type="text" name="saeViscosity" id="saeViscosity" value={selectedProduct.saeViscosity}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, saeViscosity: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.saeViscosity && (
                        <p className="text-red-500 text-sm ">{errors.saeViscosity}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="version" className="mb-1 block text-base font-medium text-[#07074D]">
                        Верзија<span className='text-red-500 tooltip' data-tip="Верзијата е задолжителна за категорија масло">*</span>
                      </label>
                      <input type="text" name="version" id="version" value={selectedProduct.version}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, version: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.version && (
                        <p className="text-red-500 text-sm ">{errors.version}</p>
                      )}
                    </div>
                  </div>
                </div>
                <h3 className='text-xl mb-4'>Општи карактеристики на Филтри</h3>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="filterType" className="mb-1 block text-base font-medium text-[#07074D]">
                        Тип на филтер<span className='text-red-500 tooltip' data-tip="Типот на филтер е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="filterType" id="filterType" value={selectedProduct.filterType}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, filterType: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.filterType && (
                        <p className="text-red-500 text-sm ">{errors.filterType}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="diameter" className="mb-1 block text-base font-medium text-[#07074D]">
                        Дијаметар<span className='text-red-500 tooltip' data-tip="Дијаметарот е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="diameter" id="diameter" value={selectedProduct.diameter}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, diameter: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.diameter && (
                        <p className="text-red-500 text-sm ">{errors.diameter}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="diameter1" className="mb-1 block text-base font-medium text-[#07074D]">
                        Дијаметар 2<span className='text-red-500 tooltip' data-tip="Дијаметарот е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="diameter1" id="diameter1" value={selectedProduct.diameter1}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, diameter1: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.diameter1 && (
                        <p className="text-red-500 text-sm ">{errors.diameter1}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="width" className="mb-1 block text-base font-medium text-[#07074D]">
                        Ширина<span className='text-red-500 tooltip' data-tip="Ширината е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="width" id="width" value={selectedProduct.width}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, width: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.width && (
                        <p className="text-red-500 text-sm ">{errors.width}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="width1" className="mb-1 block text-base font-medium text-[#07074D]">
                        Ширина 2<span className='text-red-500 tooltip' data-tip="Ширината е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="width1" id="width1" value={selectedProduct.width1}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, width1: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.width1 && (
                        <p className="text-red-500 text-sm ">{errors.width1}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="height" className="mb-1 block text-base font-medium text-[#07074D]">
                        Висина<span className='text-red-500 tooltip' data-tip="Висината е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="height" id="height" value={selectedProduct.height}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, height: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.height && (
                        <p className="text-red-500 text-sm ">{errors.height}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="height1" className="mb-1 block text-base font-medium text-[#07074D]">
                        Висина 2<span className='text-red-500 tooltip' data-tip="Висината 2 е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="height1" id="height1" value={selectedProduct.height1}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, height1: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.height1 && (
                        <p className="text-red-500 text-sm ">{errors.height1}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="length" className="mb-1 block text-base font-medium text-[#07074D]">
                        Должина<span className='text-red-500 tooltip' data-tip="Должината е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="length" id="length" value={selectedProduct.length}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, length: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.length && (
                        <p className="text-red-500 text-sm ">{errors.length}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="length1" className="mb-1 block text-base font-medium text-[#07074D]">
                        Должина 2<span className='text-red-500 tooltip' data-tip="Висината 2 е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="length1" id="length1" value={selectedProduct.length1}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, length1: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.length1 && (
                        <p className="text-red-500 text-sm ">{errors.length1}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="innerDiameter" className="mb-1 block text-base font-medium text-[#07074D]">
                        Внатрешен дијаметар<span className='text-red-500 tooltip' data-tip="Внатрешниот дијаметар е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="innerDiameter" id="innerDiameter" value={selectedProduct.innerDiameter}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, innerDiameter: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.innerDiameter && (
                        <p className="text-red-500 text-sm ">{errors.innerDiameter}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="innerDiameter2" className="mb-1 block text-base font-medium text-[#07074D]">
                        Внатрешен дијаметар 2<span className='text-red-500 tooltip' data-tip="Внатрешниот дијаметар е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="innerDiameter2" id="innerDiameter2" value={selectedProduct.innerDiameter2}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, innerDiameter2: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.innerDiameter2 && (
                        <p className="text-red-500 text-sm ">{errors.innerDiameter2}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="weight" className="mb-1 block text-base font-medium text-[#07074D]">
                        Тежина<span className='text-red-500 tooltip' data-tip="Внатрешниот дијаметар е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="weight" id="weight" value={selectedProduct.weight}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, weight: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.weight && (
                        <p className="text-red-500 text-sm ">{errors.weight}</p>
                      )}
                    </div>
                  </div>
                </div>
                <h3 className='text-xl mb-4'>Филтер за масло</h3>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="supplementaryArticle" className="mb-1 block text-base font-medium text-[#07074D]">
                        Додатни делови<span className='text-red-500 tooltip' data-tip="Додатните делови е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="supplementaryArticle" id="supplementaryArticle" value={selectedProduct.supplementaryArticle}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, supplementaryArticle: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.supplementaryArticle && (
                        <p className="text-red-500 text-sm ">{errors.supplementaryArticle}</p>
                      )}
                    </div>
                  </div>
                </div>
                <h3 className='text-xl mb-4'>Филтер за гориво</h3>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="fuelType" className="mb-1 block text-base font-medium text-[#07074D]">
                        Тип на гориво<span className='text-red-500 tooltip' data-tip="Внатрешниот дијаметар е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="fuelType" id="fuelType" value={selectedProduct.fuelType}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, fuelType: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.fuelType && (
                        <p className="text-red-500 text-sm ">{errors.fuelType}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="inletMM" className="mb-1 block text-base font-medium text-[#07074D]">
                        Влез mm<span className='text-red-500 tooltip' data-tip="Внатрешниот дијаметар е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="inletMM" id="inletMM" value={selectedProduct.inletMM}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, inletMM: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.inletMM && (
                        <p className="text-red-500 text-sm ">{errors.inletMM}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="outletMM" className="mb-1 block text-base font-medium text-[#07074D]">
                        Излез mm<span className='text-red-500 tooltip' data-tip="Внатрешниот дијаметар е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="outletMM" id="outletMM" value={selectedProduct.outletMM}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, outletMM: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.outletMM && (
                        <p className="text-red-500 text-sm ">{errors.outletMM}</p>
                      )}
                    </div>
                  </div>
                </div>
                <h3 className='text-xl mb-4'>Филтер за кабина</h3>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="cabinFilterType" className="mb-1 block text-base font-medium text-[#07074D]">
                        Тип на филтер за кабина<span className='text-red-500 tooltip' data-tip="Внатрешниот дијаметар е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="cabinFilterType" id="cabinFilterType" value={selectedProduct.cabinFilterType}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, cabinFilterType: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.cabinFilterType && (
                        <p className="text-red-500 text-sm ">{errors.cabinFilterType}</p>
                      )}
                    </div>
                  </div>
                </div>
                <h3 className='text-xl mb-4'>Адитиви</h3>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="characteristics" className="mb-1 block text-base font-medium text-[#07074D]">
                        Карактеристики<span className='text-red-500 tooltip' data-tip="Внатрешниот дијаметар е задолжителен за категорија филтри">*</span>
                      </label>
                      <textarea type="text" name="characteristics" id="characteristics" value={selectedProduct.characteristics}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, characteristics: e.target.value })}
                        className="textarea textarea-bordered w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" > </textarea>
                      {errors.characteristics && (
                        <p className="text-red-500 text-sm ">{errors.characteristics}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="application" className="mb-1 block text-base font-medium text-[#07074D]">
                        Примена (апликација)<span className='text-red-500 tooltip' data-tip="Внатрешниот дијаметар е задолжителен за категорија филтри">*</span>
                      </label>
                      <textarea type="text" name="application" id="application" value={selectedProduct.application}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, application: e.target.value })}
                        className="textarea textarea-bordered w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" ></textarea>
                      {errors.application && (
                        <p className="text-red-500 text-sm ">{errors.application}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="use" className="mb-1 block text-base font-medium text-[#07074D]">
                        Употреба<span className='text-red-500 tooltip' data-tip="Внатрешниот дијаметар е задолжителен за категорија филтри">*</span>
                      </label>
                      <textarea type="text" name="use" id="use" value={selectedProduct.use}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, use: e.target.value })}
                        className="textarea textarea-bordered w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" > </textarea>
                      {errors.use && (
                        <p className="text-red-500 text-sm ">{errors.use}</p>
                      )}
                    </div>
                  </div>
                </div>
                <h3 className='text-xl mb-4'>Бураго</h3>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="material" className="mb-1 block text-base font-medium text-[#07074D]">
                        Карактеристики<span className='text-red-500 tooltip' data-tip="Внатрешниот дијаметар е задолжителен за категорија филтри">*</span>
                      </label>
                      <input type="text" name="material" id="material" value={selectedProduct.material}
                        required
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, material: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                      {errors.material && (
                        <p className="text-red-500 text-sm ">{errors.material}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-action">
              {loading && (<span className="loading loading-spinner loading-xs"></span>)}
              <button className="btn btn-success" onClick={handleProduct} disabled={loading}>Зачувај</button>
              <button className="btn btn-warning" onClick={() => closeEditModal(true)} disabled={loading}>Откажи</button>
            </div>
            {errorMessage && (<p className='text-red-600 text-right mt-4'>{errorMessage}</p>)}
          </div>
        </div>
      )}
      {isDeleteModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="modal modal-open">
            <div className="modal-box">
              <h3 className="text-xl font-semibold">Дали сте сигурни дека сакате да го избришите <span className='font-bold text-2xl'>{productToDelete.title}</span>?</h3>
              <div className="modal-action">
                <button
                  onClick={confirmDelete}
                  className="btn btn-error"
                  disabled={loading}
                >
                  Избриши
                </button>
                <button
                  onClick={closeDeleteModal}
                  className="btn btn-primary"
                  disabled={loading}
                >
                  Откажи
                </button>
                {loading && (<span className="loading loading-spinner loading-xs"></span>)}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Products